import React from 'react'
import { Link } from 'gatsby'
import ResizedImage from './ResizedImage' // adjust import path if you placed it elsewhere

interface CommitteeCardProps {
  name: string
  role: string
  image?: string // raw image URL from frontmatter, e.g. "/uploads/img_4385.jpg"
  slug: string
  className?: string
}

const CommitteeCard: React.FC<CommitteeCardProps> = ({
  name,
  role,
  image,
  slug,
  className = '',
}) => {
  // Derive initials for placeholder when no image
  const initials = name
    ? name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
    : ''

  return (
    <Link to={slug} className={`block ${className}`}>
      <div className="card border-0 p-0 hover:shadow-lg transition-shadow h-full">
        <div className="rounded-t-lg rounded-b-none overflow-hidden">
          {image ? (
            <ResizedImage
              src={image}
              alt={name}
            />
          ) : (
            <div className="aspect-square w-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-primary/20">
              <div className="text-primary/40 text-6xl font-semibold">{initials}</div>
            </div>
          )}
        </div>

        <div className="px-4 pb-4">
          <h3 className="text-xl font-semibold mb-1">
            <span className="text-primary">{name}</span>
          </h3>
          <p className="text-text-light mb-3">{role}</p>
          <div className="text-primary font-medium">Learn More →</div>
        </div>
      </div>
    </Link>
  )
}

export default CommitteeCard